import { css } from '@emotion/react'
import styled from '@emotion/styled'
import { Skeleton, TableCell, TableRow } from '@mui/material'
import { TableColumn } from '@global/types'
import { CvsTable } from '../table/cvs-table'

const TableContainer = styled.div`
  background: #fff;
`

const tableCell = css`
  border-bottom-color: rgba(0, 0, 0, 0.1);
`

interface Props {
  columns: TableColumn[]
  overrideContainerStyle?: any
  overrideTableStyle?: any
}

export const TableLoader = ({ columns, overrideContainerStyle, overrideTableStyle }: Props) => (
  <TableContainer>
    <CvsTable
      rows={Array(10).fill({}) as never[]}
      columns={columns}
      noAdd
      noPagination
      overrideTableWrapperStyles={overrideTableStyle}
      overrideRootStyles={overrideContainerStyle}
    >
      {(_, i) => (
        <TableRow key={i}>
          {columns.map((c, colIdx) => (
            <TableCell
              key={colIdx}
              component="td"
              scope="row"
              css={tableCell}
              sx={{ width: c.width ? c.width : 'auto' }}
            >
              <Skeleton />
            </TableCell>
          ))}
        </TableRow>
      )}
    </CvsTable>
  </TableContainer>
)
